const FETCH_COLLABORATORS_INFO = 'avisos/responsibleUpdate/FETCH_COLLABORATORS_INFO';
const FETCH_COLLABORATORS_INFO_COMPLETED = 'avisos/responsibleUpdate/FETCH_COLLABORATORS_INFO_COMPLETED';
const FETCH_COLLABORATORS_INFO_FAILED = 'avisos/responsibleUpdate/FETCH_COLLABORATORS_INFO_FAILED';
const UPDATE_USER_RESPONSIBLE_BULK = 'avisos/responsibleUpdate/UPDATE_USER_RESPONSIBLE_BULK';
const UPDATE_USER_RESPONSIBLE_BULK_COMPLETED = 'avisos/responsibleUpdate/UPDATE_USER_RESPONSIBLE_BULK_COMPLETED';
const UPDATE_USER_RESPONSIBLE_BULK_FAILED = 'avisos/responsibleUpdate/UPDATE_USER_RESPONSIBLE_BULK_FAILED';

export {
  FETCH_COLLABORATORS_INFO,
  FETCH_COLLABORATORS_INFO_COMPLETED,
  FETCH_COLLABORATORS_INFO_FAILED,
  UPDATE_USER_RESPONSIBLE_BULK,
  UPDATE_USER_RESPONSIBLE_BULK_COMPLETED,
  UPDATE_USER_RESPONSIBLE_BULK_FAILED
};
